/* src/app/shared/components/count-down/count-down.component.less */
.count-down {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.count-down.count-down-medium {
  height: 10.1rem;
  width: 10.1rem;
}
.count-down.count-down-medium .counter {
  font-size: 4.8rem;
  font-weight: 600;
  line-height: 4.2rem;
}
.count-down.count-down-medium .counter-loader {
  height: 10.1rem;
  width: 10.1rem;
  background-size: 10.1rem 10.1rem;
}
.count-down.count-down-small {
  height: 5.2rem;
  width: 5.2rem;
}
.count-down.count-down-small .counter {
  font-size: 2.3rem;
  font-weight: 600;
  line-height: 3.2rem;
}
.count-down.count-down-small .counter-loader {
  height: 5.2rem;
  width: 5.2rem;
  background-size: 5.2rem 5.2rem;
}
.count-down .counter {
  color: #ffffff;
  z-index: 1;
}
.count-down .counter-loader {
  position: absolute;
  animation: rotate 1s linear infinite;
  background-image: url("./media/icon-loading.png");
  background-repeat: no-repeat;
  transform: rotate(-90deg);
}
@keyframes rotate {
  from {
    transform: rotate(-90deg);
  }
  to {
    transform: rotate(270deg);
  }
}
/*# sourceMappingURL=count-down.component.css.map */
